module.exports = __webpack_public_path__ + "img/tuerueberdachung_1.5b32d4cb.jpg";